import { render } from "./PostNodeHead.vue?vue&type=template&id=12d5e683&ts=true"
import script from "./PostNodeHead.vue?vue&type=script&lang=ts"
export * from "./PostNodeHead.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__